import { PInlineNotification } from "@porsche-design-system/components-react"
import { defineMessages, FormattedMessage } from "react-intl"
import { FieldWrapper } from "../FieldWrapper"

const messages = defineMessages({
	updatePrice: {
		defaultMessage:
			"Price in the listing section may not be valid anymore. Please go to the listing section and check it.",
		id: "vehicleDetails.overview.inventory.updateModal.listingChange.updatePrice",
	},
})

export const ListingChangeForm = () => {
	return (
		<FieldWrapper>
			<PInlineNotification state="warning" dismissButton={false}>
				<FormattedMessage {...messages.updatePrice} />
			</PInlineNotification>
		</FieldWrapper>
	)
}
